/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFaqListResponseDto } from '../../models/lexplus-faq-list-response-dto';

export interface FaqControllerFindAllPaginatedV1$Params {

/**
 * Narrows to the FAQs filed under any of the given categories. **Format:** filter.categoryId=$in:ID,ID — a bare ID or `$eq:ID` names one. **Example:** filter.categoryId=$in:1,2
 */
  'filter.categoryId'?: Array<string>;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by status query param.
 *
 * **Format:** filter.status={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.status=$eq:John Doe&filter.status=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.status'?: Array<string>;

/**
 * Filter by lexplusVersion query param.
 *
 * **Format:** filter.lexplusVersion={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.lexplusVersion=$eq:John Doe&filter.lexplusVersion=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.lexplusVersion'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=prio:DESC&sortBy=status:DESC
 *
 *
 * **Default Value:** prio:ASC
 *
 * **Available Fields**
 * - prio
 *
 * - status
 *
 * - faqID
 *
 * - lexplusVersion
 *
 * - categoryName
 *
 * - title
 */
  sortBy?: Array<'prio:ASC' | 'prio:DESC' | 'status:ASC' | 'status:DESC' | 'faqID:ASC' | 'faqID:DESC' | 'lexplusVersion:ASC' | 'lexplusVersion:DESC' | 'categoryName:ASC' | 'categoryName:DESC' | 'title:ASC' | 'title:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** faqID,status,prio,lexplusVersion,uebersetzung
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function faqControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: FaqControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFaqListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('filter.categoryId', params['filter.categoryId'], {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.status', params['filter.status'], {});
    rb.query('filter.lexplusVersion', params['filter.lexplusVersion'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFaqListResponseDto>;
    })
  );
}

faqControllerFindAllPaginatedV1.PATH = '/v1/faq/paginated';
